import axiosClient from '../axiosClient';
import store from '@/store';

export default {
  async getUsers() {
    try {
      const response = await axiosClient.get('/users');
      return response.data.data;
    } catch (error) {
      return Promise.reject(error.response?.data?.message || "errors.failed_to_fetch_data");
    }
  },
  async deleteUser(id) {
    try {
      await axiosClient.delete(`/users/${id}`);
    } catch (error) {
      return Promise.reject(error.response?.data?.message || "Failed to delete user");
    }
  },
  async addUser(payload) {
    try {
      await axiosClient.post("/users", payload);
    } catch (error) {
      return Promise.reject(error.response?.data?.message || "Failed to add user.");
    }
  },
  async updateUser(payload) {
    console.log("Updating user with payload:", payload);
    try {
      const response = await axiosClient.put('/users', payload);
  
      const updatedUser = {
        username: response.data.data.user.name,
        email: response.data.data.user.email,
      };

      store.dispatch('auth/updateUser', updatedUser);
    } catch (error) {
      return Promise.reject(error.response?.data?.message || "Failed to update user.");
    }
  }
};
